import styles from './styles.module.scss';
import { routes } from '@const/routes';
import Button from '@components/common/button';

const Footer = () => {
    return (
        <div className={styles.wrapper}>
            <p className={styles.date}>© 2025 XEPPT</p>
            <div className={styles.links_wrapper}>
                <Button
                    variant="text-gray"
                    onClick={() => window.open(routes.terms_of_service, '_blank')}>
                    Terms of Service
                </Button>
                <Button
                    variant="text-gray"
                    onClick={() => window.open(routes.privacy_policy, '_blank')}>
                    Privacy Policy
                </Button>
            </div>
        </div>
    );
};

export default Footer;
